import * as Store from '../weborder/Store';

const activeLanguageCode = (
  languages: Store.Language[] = [],
  fallbackLanguage = 'en',
): string => {
  if (languages.length === 0) {
    return fallbackLanguage;
  }

  const activeLanguage = languages.find((language) => language.active);
  return activeLanguage ? activeLanguage.code : fallbackLanguage;
};

export const getUtils = {
  activeLanguageCode,
};
